import { useQuery } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from '../../../forBinding';
import { AreaDTO, CultureType } from '../../types';

interface AreasResponse {
    docs: AreaDTO[];
    totalDocs: number;
    limit: number;
    page: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
    nextPage: number | null;
    prevPage: number | null;
}

interface UseGetAreasParams {
    page?: number;
    limit?: number;
    filter?: string;
    culture?: CultureType | CultureType[];
    sortAsc?: boolean;
    enabled?: boolean;
}

export function useGetAreas({
    page = 1,
    limit = 100,
    filter,
    culture,
    sortAsc,
    enabled = true
}: UseGetAreasParams = {}) {
    const forBinding = useForBindingId();
    const query = useQuery({
        enabled,
        queryKey: ['areas', forBinding, page, limit, filter, culture, sortAsc],
        queryFn: async () => {
            const params = new URLSearchParams();
            params.set('page', String(page));
            params.set('limit', String(limit));

            if (forBinding) params.set('forBinding', forBinding);
            if (filter) params.set('filter', filter);
            if (sortAsc !== undefined) params.set('sortAsc', String(sortAsc));

            const cultures = Array.isArray(culture) ? culture : culture ? [culture] : [];
            cultures.forEach((item) => params.append('culture', item));

            const { data } = await api.get<AreasResponse>("/user/prop/area/findAll", {
                params,
            });
            return {
                ...data,
                docs: data.docs.map((area) => ({
                    ...area,
                    avatarUrl: area.avatarUrl ?? area.avatar?.url,
                })),
            };
        }

    });

    return {
        ...query,
        data: query.data?.docs ?? [],
        pagination: query.data ? {
            totalDocs: query.data.totalDocs,
            totalPages: query.data.totalPages,
            page: query.data.page,
            hasPrevPage: query.data.hasPrevPage,
            hasNextPage: query.data.hasNextPage,
            prevPage: query.data.prevPage,
            nextPage: query.data.nextPage,
        } : null,
    }


}
